var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"title":"Campaign Applications","product-type":"campaign"}})
}
var staticRenderFns = []

export { render, staticRenderFns }